import React, { Component } from 'react';
import { connect } from 'react-redux';
import WoodStrengthClass from './components/WoodStrengthClass';

class WoodMaterial extends Component {
 
  render() {
    
    return (
      <div className="calculation">
        <WoodStrengthClass />
      </div>
    );
  }

}

const mapStateToProps = (state) => ({
  appStatus: state.main.status,
  serviceTemperature: state.selectors.material.serviceTemperature
});

const mapDispatchToProps = {
  setServiceTemperature: (value) => ({ type: 'SET_SERVICE_TEMPERATURE', payload: value })
};

export default connect(mapStateToProps, mapDispatchToProps)(WoodMaterial);



// WEBPACK FOOTER //
// ./src/views/Material/components/WoodMaterial/index.js